export default "__VITE_ASSET__B7N3EdWj__"